import { gql } from 'apollo-angular';

export const GET_NON_BPS_OPERATORS = gql`
  query GetMyNonBpsOperatorApplications($pageable: PageableParamInput!) {
    getMyNonBpsOperatorApplications(pageable: $pageable) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        attachableDiscriminator
        businessScopeDescription
        deleted
        deletedAt
        id
        importationLicenseExpiration
        otherAttachmentName
        registrationStatus
        registrationType
        tin
        traImportationLicense
        uuid
        natureOfNonBps {
          active
          code
          name
          uuid
        }
      }
    }
  }
`;

export const GET_NON_BPS_OPERATOR_BY_UUID = gql`
  query GetNonBpsOperatorByUuid($uuid: String!) {
    getNonBpsOperatorByUuid(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        businessScopeDescription
        id
        importationLicenseExpiration
        otherAttachmentName
        registrationStatus
        registrationType
        tin
        traImportationLicense
        uuid
        importationLicences {
          active
          ewuraLicenseNumber
          id
          incorpRegistrationCertificateIssuanceDate
          incorpRegistrationCertificateNumber
          licenseExpireDate
          licenseStartDate
          licenseYear
          lisenceIssuedDate
          nameOfCompany
          omcNumber
          uuid
        }
        natureOfNonBps {
          active
          code
          name
          uuid
        }
        attachments {
          active
          id
          minioObjectName
          otherAttachmentName
          uuid
          attachable {
            attachableDiscriminator
            bucketName
            id
            otherAttachmentName
            registrationType
            uuid
          }
          attachmentType {
            active
            fileSize
            fileType
            id
            kind
            name
            uuid
          }
        }
      }
    }
  }
`;

export const GET_NON_BPS_APPROVED_TERMINALS = gql`
  query GetAllTerminalRegistration($pageableParam: PageableParamInput) {
    getAllTerminalRegistration(pageableParam: $pageableParam) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        status
        terminalName
        uuid
        company {
          name
          registrationStatus
          uuid
        }
      }
    }
  }
`;

export const SAVE_NON_BPS_PRODUCT_REQUEST = gql`
  mutation SaveNonBpsProductRequest($input: NonBpsProductRequestDtoInput!) {
    saveNonBpsProductRequest(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        deletedBy
        destinationFacilityName
        destinationLocation
        id
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        uuid
      }
    }
  }
`;

export const GET_NON_BPS_PRODUCT_REQUEST_BY_UUID = gql`
  query GetNonBpsProductRequestByUuid($uuid: String!) {
    getNonBpsProductRequestByUuid(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        createdAt
        id
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        updatedAt
        uuid
        portOfEntry {
          active
          code
          description
          maxCapacityMt
          portName
          regionName
          uuid
          regionUuid
        }
        nonBpsOperator {
          active
          businessScopeDescription
          id
          importationLicenseExpiration
          uuid
          natureOfNonBps {
            name
            uuid
          }
        }
        productQuantities {
          active
          destinationCountry
          destinationRegion
          id
          quantity
          uuid
          product {
            active
            isBps
            minCapacityMt
            productName
            uuid
            productCategory {
              active
              code
              name
              uuid
            }
          }
          unitOfMeasure {
            active
            code
            conversionFactor
            name
            uuid
          }
          usage {
            active
            usageName
            uuid
          }
          consignees {
            active
            consigneeCompanyName
            consigneeCountry
            consigneeRegistrationNumber
            email
            id
            phoneNumber
            uuid
            directors {
              active
              email
              id
              name
              phoneNumber
              uuid
            }
          }
        }
        terminal {
          active
          status
          terminalName
          uuid
        }
      }
    }
  }
`;

export const GET_MY_NON_BPS_PRODUCT_REQUESTS = gql`
  query GetMyNonBpsProductRequests($pageable: PageableParamInput!) {
    getMyNonBpsProductRequests(pageable: $pageable) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        attachableDiscriminator
        createdAt
        expectedArrivalEndDate
        expectedArrivalStartDate
        id
        loadPort
        otherAttachmentName
        otherTerminalName
        registrationType
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        uuid
        vesselName
        portOfEntry {
          active
          portName
          uuid
          regionName
        }
        productQuantities {
          active
          destinationCountry
          destinationRegion
          id
          quantity
          uuid
          product {
            active
            isBps
            minCapacityMt
            productName
            uuid
          }
        }
      }
    }
  }
`;

export const SUBMIT_NON_BPS_PRODUCT_REQUEST = gql`
  mutation SubmitNonBpsProductRequestToWorkflow($uuid: String!) {
    submitNonBpsProductRequestToWorkflow(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        id
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        uuid
      }
    }
  }
`;

export const DELETE_NON_BPS_PRODUCT_REQUEST = gql`
  mutation DeleteNonBpsProductRequest($uuid: String!) {
    deleteNonBpsProductRequest(uuid: $uuid) {
      code
      data
      dataList
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SAVE_NON_BPS_PRODUCT_REQUEST_QUANTITIES = gql`
  mutation SaveNonBpsProductRequestQuantities($input: NonBpsProductRequestStep1DtoInput!) {
    saveNonBpsProductRequestQuantities(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        id
        loadPort
        otherAttachmentName
        otherTerminalName
        registrationType
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        uuid
        vesselName
      }
    }
  }
`;

export const SAVE_NON_BPS_PRODUCT_ARRIVAL_DETAILS = gql`
  mutation SaveNonBpsProductRequestArrivalDetails($input: NonBpsProductRequestStep2DtoInput!) {
    saveNonBpsProductRequestArrivalDetails(input: $input) {
      code
      data {
        active
        attachableDiscriminator
        bucketName
        id
        loadPort
        otherAttachmentName
        otherTerminalName
        registrationType
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        uuid
        vesselName
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SAVE_NON_BPS_PRODUCT_REQUEST_SUPPLIER_DETAILS = gql`
  mutation SaveNonBpsProductRequestSupplierDetails($input: NonBpsProductRequestStep3DtoInput!) {
    saveNonBpsProductRequestSupplierDetails(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        id
        loadPort
        otherAttachmentName
        otherTerminalName
        registrationType
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        uuid
        vesselName
      }
    }
  }
`;

export const SAVE_NON_BPS_PRODUCT_REQUEST_CONSIGNEE_DETAILS = gql`
  mutation SaveNonBpsProductRequestConsigneeDetails($input: NonBpsProductRequestStep4DtoInput!) {
    saveNonBpsProductRequestConsigneeDetails(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        id
        loadPort
        otherAttachmentName
        otherTerminalName
        registrationType
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        uuid
        vesselName
      }
    }
  }
`;

export const GET_NON_BPS_REQUEST_PROGRESS = gql`
  query GetNonBpsProductRequestProgress($uuid: UUID!) {
    getNonBpsProductRequestProgress(uuid: $uuid) {
      code
      data {
        active
        allSectionsComplete
        completionPercentage
        id
        sectionAComplete
        sectionACompletedAt
        sectionBComplete
        sectionBCompletedAt
        sectionCComplete
        sectionCCompletedAt
        sectionDComplete
        sectionDCompletedAt
        sectionEComplete
        sectionECompletedAt
        updatedAt
        updatedBy
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const GET_NON_BPS_BY_UUID = gql`
  query GetNonBpsProductRequestByUuid($uuid: UUID!) {
    getNonBpsProductRequestByUuid(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        expectedArrivalEndDate
        expectedArrivalStartDate
        id
        loadPort
        otherTerminalName
        registrationType
        status
        supplierCountryId
        supplierCountryName
        supplierName
        supplierRegistrationNumber
        uuid
        vesselName
        createdAt
        attachments {
          active
          id
          minioObjectName
          uuid
          attachable {
            attachableDiscriminator
            bucketName
            id
            otherAttachmentName
            registrationType
            uuid
          }
          attachmentType {
            active
            fileSize
            fileType
            id
            kind
            name
            uuid
          }
        }
        portOfEntry {
          active
          code
          description
          hasMinimumCapacity
          maxCapacityMt
          portName
          uuid
          regionName
        }
        productQuantities {
          active
          destinationCountry
          destinationRegion
          id
          quantity
          uuid
          unitOfMeasure {
            active
            code
            name
            uuid
          }
          product {
            active
            isBps
            minCapacityMt
            productName
            uuid
          }
          consignees {
            active
            allocatedQuantity
            id
            updatedAt
            uuid
            consignee {
              active
              companyName
              countryName
              email
              id
              phoneNumber
              registrationNumber
              uuid
              directors {
                active
                email
                id
                name
                phoneNumber
                uuid
              }
            }
            quantity {
              active
              destinationCountry
              destinationRegion
              id
              quantity
              uuid
              usage {
                active
                isTransit
                usageName
                uuid
              }
              unitOfMeasure {
                active
                code
                name
                uuid
              }
              product {
                active
                isBps
                minCapacityMt
                productName
                uuid
              }
            }
          }
          usage {
            active
            isTransit
            usageName
            uuid
          }
        }
        terminal {
          active
          address
          attachableDiscriminator
          bucketName
          otherAttachmentName
          referenceNumber
          registrationType
          status
          terminalName
          uuid
        }
      }
    }
  }
`;
